import axios from 'axios';
import { getAuthHeader } from './userInfo-actions';
import { notificationsDataActions } from './notifications-slice';

export const getNotifications = () => {
  return async dispatch => {
    let notificationsData = await axios.get(
      `${process.env.REACT_APP_API_PATH_MAYAHII_NOTIFICATIONS}/notification/web`,
      {
        headers: getAuthHeader()
      }
    );

    if (notificationsData.data) {
      dispatch(
        notificationsDataActions.notificationsData({
          userNotifications: notificationsData.data
        })
      );
    }
  };
};

export const updateNotifications = userId => {
  return async () => {
    await axios.post(
      `${process.env.REACT_APP_API_PATH_MAYAHII_NOTIFICATIONS}/notification/web`,
      {
        userId
      },
      { headers: getAuthHeader() }
    );
  };
};
